import React, { useEffect, useState, useRef } from 'react';
import useForceUpdate from 'use-force-update';
import { isNumber } from '../../Utils/Common';
import { getGeoLocation } from '../../Utils/function';
import PropagateLoader from "react-spinners/PropagateLoader";
import { FING_PAY_ADHAR_PAY_API, FING_PAY_GENERATE_OTP, BIOMETRIC_DEVICE_INFO } from '../../Utils/appConstants';
import { postRequest } from '../../Utils/AppApi';
import { useHistory } from "react-router-dom";
import { toast } from 'react-toastify';
import Select from 'react-select';
import { Checkbox, Modal, Button, Input } from 'antd';
import xmlJs from 'xml-js';
import axios from 'axios';
import AfterSubmit from '../../container/partnerEkyc';
import BioDevice from '../aepsInstant/bioDevice';

function Cashwithdrawal(props) {
    const history = useHistory();
    const forceUpdate = useForceUpdate();
    const [isLoading, setLoading] = useState(false);
    const [getDataField, setDataField] = useState(props.existData);
    const [getDataError, setDataError] = useState({});
    const [latitude, setLatitude] = useState("");
    const [longitude, setLongitude] = useState("");
    const [isConsent, setConsent] = useState("N");
    const [biometricData, setBiometricData] = useState(null);
    const [getBankList, setBankList] = useState([]);
    const [isSubmit, setSubmit] = useState(false);
    const [isAmount, setAmount] = useState(null);
    const [fingerprintXmlData, setFingerprintXmlData] = useState(null)
    const [status, setStatus] = useState(null);
    const [statusMessage, setStatusMessage] = useState(null);
    const [transactionId, setTransactionId] = useState(null);
    const [isAuthAePSModel, setAuthAePSModel] = useState(false);
    const [isAuthAePSTitle, setAuthAePSTitle] = useState("Customer Biometric for Aadhaar Pay");
    const [isDeviceConnected, setIsDeviceConnected] = useState(false);
    const [selectedBank, setSelectedBank] = useState(null);

    // 🔥 OTP states
    const [showOtpPopup, setShowOtpPopup] = useState(false);
    const [otpValue, setOtpValue] = useState("");
    const [fpTransactionId, setFpTransactionId] = useState("");
    const [otpTimer, setOtpTimer] = useState(45);
    const [otpExpired, setOtpExpired] = useState(false);
    const [otpLoading, setOtpLoading] = useState(false);
    const [isOtpVerified, setIsOtpVerified] = useState(false);
    const timerIntervalRef = useRef(null);

    const bankSelect = useRef("");
    const aadharInput = useRef("");
    const mobileInput = useRef("");
    const amountInput = useRef("");

    const detectFingerprintDevice = async () => {
        try {
            const res = await axios({
                method: 'DEVICEINFO',
                url: props.deviceConfig.infoUrl,
                headers: { "Content-Type": "text/xml; charset=UTF-8" }, data: ` `
            });
            const jsonData = xmlJs.xml2json(res.data, { compact: true });
            const parsed = JSON.parse(jsonData);
            const params = parsed?.DeviceInfo?.additional_info?.Param;
            let srnoValue = null;
            if (Array.isArray(params)) {
                const srnoParam = params.find(p => p._attributes?.name === "srno");
                srnoValue = srnoParam?._attributes?.value;
            } else if (params?._attributes?.name === "srno") {
                srnoValue = params._attributes?.value;
            }
            const isConnected = !!srnoValue && srnoValue.trim() !== "";
            return isConnected;
        } catch (err) {
            return false;
        }
    };

    const onChangeValueSelect = (event) => {
        const { value } = event;
        props.existInputData(event, value);
        setDataField({ ...getDataField, "bankiin": value });
        setSelectedBank(event);
    };

    const clearFormField = () => {
        props.clearExistInputData();
        setConsent('N');
        setDataError({});
        setDataField([]);
        setSelectedBank(null);
        // Reset OTP states
        setOtpValue("");
        setFpTransactionId("");
        setShowOtpPopup(false);
        setOtpExpired(false);
        setOtpTimer(45);
        setIsOtpVerified(false);
        if (timerIntervalRef.current) clearInterval(timerIntervalRef.current);
    };

    const handleRetry = () => {
        setFingerprintXmlData(null);
        setBiometricData(null);
        setStatus(null);
        setStatusMessage(null);
        setSubmit(false);
        setOtpValue("");
        setFpTransactionId("");
        setShowOtpPopup(false);
        setOtpExpired(false);
        setOtpTimer(45);
        setIsOtpVerified(false);
        if (timerIntervalRef.current) clearInterval(timerIntervalRef.current);
    };

    const onChangeValue = (event) => {
        props.existInputData(event);
        const { name, value } = event.target;
        if (name === "amount") {
            setAmount(value)
            if (!handleAmountChange(value)) {
                let formObject = {};
                formObject.validamount = true;
                setDataError(formObject);
            } else {
                setDataError({})
            }
            setConsent('N');
            setDataField({ ...getDataField, [name]: value });
        } else {
            setDataError({});
            setDataField({ ...getDataField, [name]: value });
        }
    };

    const handleAmountChange = (amount) => {
        if (amount) {
            const amountString = amount.toString();
            const lastTwoDigits = amountString.slice(-2);
            if (lastTwoDigits === "00" || lastTwoDigits === "50") {
                return true;
            } else {
                return false;
            }
        }
    };

    const FormValidate = () => {
        let formValid = true;
        let formObject = {};
        setDataError({})
        if (getDataField && getDataField.length === 0) {
            formValid = false;
        }
        let array = ["bankiin", "aadhaar", "mobile", "amount"];
        array.forEach(element => {
            if (getDataField[element] === "" || typeof getDataField[element] === "undefined") {
                formObject[element] = true;
                formValid = false;
            }
        });
        if (!handleAmountChange(isAmount)) {
            toast.error("Invalid TXN Amount, Please enter an amount that is a multiple of Rs. 100 and Rs. 50.");
            formValid = false;
        }
        if (getDataField.amount > 10000) {
            toast.error("Maximum Aadhaar Pay amount is Rs: 10,000");
            formValid = false;
        }
        if (getDataField.aadhaar && getDataField.aadhaar.length !== 12) {
            toast.error("Aadhaar numbers should be 12 digits long");
            formValid = false;
        }
        if (getDataField.mobile && getDataField.mobile.length !== 10) {
            toast.error("Mobile number should be 10 digits long");
            formValid = false;
        }
        setDataError(formObject);
        return formValid;
    };

    // 🔥 OTP Generation (for AadhaarPay – transactionType = "MO")
    const generateOtp = async () => {
        if (!FormValidate()) return;
        if (isConsent === 'N') {
            toast.error("Please accept consent declaration");
            return;
        }
        const deviceStatus = await detectFingerprintDevice();
        setIsDeviceConnected(deviceStatus);
        if (!deviceStatus) {
            toast.error("Fingerprint device not connected, check connection and try again");
            return;
        }

        setOtpLoading(true);
        const payload = {
            bankiin: getDataField.bankiin,
            mobile: getDataField.mobile,
            amount: getDataField.amount,
            aadhaar: getDataField.aadhaar,
            latitude: latitude,
            longitude: longitude,
            transactionType: "MO", // 🔥 AadhaarPay OTP
        };
        postRequest(FING_PAY_GENERATE_OTP, payload, history)
            .then((response) => {
                setOtpLoading(false);
                if (response.success === true) {
                    setFpTransactionId(response.data.fpTransactionId);
                    setShowOtpPopup(true);
                    setOtpTimer(45);
                    setOtpExpired(false);
                    setOtpValue("");
                    setIsOtpVerified(false);
                    startOtpTimer();
                    toast.success("OTP sent to registered mobile");
                } else {
                    toast.error(response.message || "Failed to generate OTP");
                }
            })
            .catch(() => {
                setOtpLoading(false);
                toast.error("Failed to generate OTP");
            });
    };

    // 🔥 OTP Timer
    const startOtpTimer = () => {
        if (timerIntervalRef.current) clearInterval(timerIntervalRef.current);
        setOtpTimer(45);
        setOtpExpired(false);
        timerIntervalRef.current = setInterval(() => {
            setOtpTimer((prev) => {
                if (prev <= 1) {
                    clearInterval(timerIntervalRef.current);
                    setOtpExpired(true);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);
    };

    // 🔥 Resend OTP
    const resendOtp = () => {
        generateOtp();
    };

    // 🔥 Verify OTP (client-side – proceed to biometric)
    const verifyOtp = () => {
        if (otpValue.length !== 6) {
            toast.error("Please enter a valid 6‑digit OTP");
            return;
        }
        if (otpExpired) {
            toast.error("OTP expired. Please resend.");
            return;
        }
        setIsOtpVerified(true);
        setShowOtpPopup(false);
        // Open biometric modal
        setAuthAePSModel(true);
    };

    const scanFingerPrintData = async () => {
        const status = await detectFingerprintDevice();
        setIsDeviceConnected(status);
        if (!status) {
            toast.error("Fingerprint device not connected, check connection and try again");
            setConsent('N');
            return;
        }
        await axios({
            method: 'CAPTURE',
            url: props.deviceConfig.captureUrl,
            headers: { "Content-Type": "text/xml; charset=UTF-8" },
            data: props.deviceConfig.xmlData
        }).then(response => {
            const jsonData = xmlJs.xml2json(response.data, { compact: true, spaces: 4 });
            let XMLjson = JSON.parse(jsonData);
            if (jsonData.length < 1500) {
                scanFingerPrintData();
                return;
            }
            if (XMLjson && XMLjson.PidData?.Resp?._attributes?.errCode === "0") {
                setFingerprintXmlData(response.data)
            } else {
                setFingerprintXmlData(null)
            }
        }).catch(error => {
            console.log("error -----------", error)
        })
    };

    const scanFinger = () => {
        if (FormValidate() && isConsent === 'Y') {
            const amount = parseFloat(getDataField.amount);
            if (amount > 5000) {
                generateOtp();
            } else {
                setAuthAePSModel(true);
            }
        } else if (isConsent !== 'Y') {
            toast.error("Please accept consent declaration");
        }
    };

    const handleSubmit = () => {
        if (isConsent === 'N') {
            toast.error("Please aadhaar accept consent declaration");
            return false;
        } else if (FormValidate()) {
            setLoading(true)
            const payload = {
                bankiin: getDataField.bankiin,
                mobile: getDataField.mobile,
                amount: getDataField.amount,
                biometricData: biometricData,
                aadhaar: getDataField.aadhaar,
                latitude: latitude,
                longitude: longitude,
                isXml: true,
                consent: isConsent
            };

            // 🔥 If OTP was verified, include otp and txnOtpRequestId
            if (isOtpVerified && fpTransactionId) {
                payload.otp = otpValue;
                payload.txnOtpRequestId = fpTransactionId;
            }

            postRequest(FING_PAY_ADHAR_PAY_API, payload, history).then((response) => {
                if (response.success === true) {
                    setStatus(1)
                    setStatusMessage(response.message);
                    toast.success(response.message);
                } else {
                    setStatus(0)
                    setStatusMessage(response.message);
                    toast.error(response.message);
                }
                setTransactionId(response.transactionId);
                setTimeout(() => {
                    setAuthAePSModel(false);
                    setFingerprintXmlData(null);
                    setBiometricData(null);
                    setLoading(false);
                    setSubmit(true);
                }, 1000);
            })
        }
    } // eslint-disable-line react-hooks/exhaustive-deps

    const onChangeChackBox = async (e) => {
        const newChecked = e.target.checked;
        if (newChecked) {
            if (!FormValidate()) {
                toast.error("Please fill all required fields and ensure validations are met");
                return;
            }
            const status = await detectFingerprintDevice();
            setIsDeviceConnected(status);
            if (!status) {
                toast.error("device not connected, check connection and try again");
                return;
            }
        }
        setConsent(newChecked ? 'Y' : 'N');
    };

    const handleCloseModal = () => {
        setAuthAePSModel(false)
    };

    const fetchLocation = async () => {
        let data = await getGeoLocation();
        setLatitude(data.latitude);
        setLongitude(data.longitude);
    };

    useEffect(() => {
        if (fingerprintXmlData) {
            setBiometricData(fingerprintXmlData)
        }
    }, [fingerprintXmlData]);

    useEffect(() => {
        setAuthAePSTitle("Customer Biometric for Aadhaar Pay")
        fetchLocation();
        return () => {
            setSubmit(false);
            if (timerIntervalRef.current) clearInterval(timerIntervalRef.current);
        }
    }, []);

    useEffect(() => {
        if (props.getBankList && props.getBankList.length > 0) {
            setBankList(props.getBankList);
        }
    }, [props.getBankList]);

    useEffect(() => {
        if (biometricData) {
            handleSubmit();
        }
    }, [biometricData]);

    useEffect(() => {
        if (props.existData) {
            forceUpdate();
            setDataField(props.existData);
            if (props.existData.bankiin && getBankList.length > 0) {
                const bank = getBankList.find(b => b.value === props.existData.bankiin);
                if (bank) {
                    setSelectedBank(bank);
                }
            }
        }
    }, [props.existData, getBankList]);

    useEffect(() => {
        if (!isSubmit && getDataField.bankiin && getBankList.length > 0) {
            const bank = getBankList.find(b => b.value === getDataField.bankiin);
            if (bank) {
                setSelectedBank(bank);
            }
        }
    }, [isSubmit, getDataField, getBankList]);

    if (isLoading) {
        return <div className="content text-center" style={{ margin: "250px 0" }}>
            <PropagateLoader color="#5851D2" loading={isLoading} size={25} />
        </div>
    }

    return (
        <div>
            <div className="row">
                <div className="col-md-12">
                    <div className='card rounded-0 card-body'>{isSubmit ? <><div className='text-right'>
                        <Button className='bg bg-primary mr-3' onClick={() => clearFormField()}>New Transaction</Button>
                        {status === 0 && <Button className='bg bg-info mr-3' onClick={() => handleRetry()}>Retry</Button>}
                        {transactionId && <Button className='bg bg-primary' onClick={() => history.push(`/aepsinvoice/${transactionId}`)}>View Invoice</Button>}
                    </div><AfterSubmit status={status} message={statusMessage} />
                    </> :
                        <div className='row'>
                            <div className='col-sm-6 col-md-4 col-lg-4'>
                                <div className="form-group">
                                    <div className="input-group">
                                        <label>Bank Name</label>
                                        <Select showSearch status={`${getDataError && getDataError.bank ? "error" : ""}`} options={getBankList} className={`normal-light w-100`} classNamePrefix="select" ref={bankSelect} name='bankiin' onChange={(e) => onChangeValueSelect(e)} placeholder="-Select Bank-" value={selectedBank} />
                                        {getDataError && getDataError.bankiin && <span className="error text-danger">The field is required</span>}
                                    </div>
                                </div>
                            </div>
                            <div className='col-sm-6 col-md-4 col-lg-4'>
                                <div className="form-group">
                                    <label>Aadhaar Number</label>
                                    <input type="text" className={`form-control normal-light ${getDataError && getDataError.aadhaar ? "is-invalid" : ""}`} name="aadhaar" maxLength={12} value={getDataField && getDataField.aadhaar} onKeyDown={isNumber} onChange={(e) => onChangeValue(e)} ref={aadharInput} />
                                    {getDataError && getDataError.aadhaar && <span className="error text-danger">The field is required</span>}
                                </div>
                            </div>
                            <div className='col-sm-6 col-md-4 col-lg-4'>
                                <div className="form-group">
                                    <label>Mobile Number</label>
                                    <input type="text" className={`form-control normal-light ${getDataError && getDataError.mobile ? "is-invalid" : ""}`} name="mobile" value={getDataField && getDataField.mobile} onKeyDown={isNumber} onChange={(e) => onChangeValue(e)} maxLength={10} ref={mobileInput} />{getDataError && getDataError.mobile && <span className="error text-danger">The field is required</span>}
                                </div>
                            </div>
                            <div className='col-sm-6 col-md-4 col-lg-4'>
                                <div className="form-group">
                                    <label>Amount</label>
                                    <input type="text" className={`form-control normal-light ${getDataError && getDataError.amount ? "is-invalid" : ""}`} name="amount" value={getDataField && getDataField.amount} onKeyDown={isNumber} maxLength={5} onChange={(e) => onChangeValue(e)} ref={amountInput} />{getDataError && getDataError.amount && <span className="error text-danger">The field is required</span>}
                                    {getDataError && getDataError.validamount && <span className="error text-danger">Invalid TXN Amount, Please enter an amount that is a multiple of Rs. 100 and Rs. 50.</span>}
                                </div>
                            </div>
                            <div className='col-sm-12 col-md-12 col-lg-12'>
                                <div className='form-group'>
                                    <Checkbox className='d-flex' checked={isConsent === "Y" ? true : false} onChange={onChangeChackBox}>I hereby give my voluntary consent to SR PAY Private Limited, use my Aadhaar/ VID number & biometric to authenticate from UIDAI for the purpose of AEPS activation.</Checkbox>
                                </div>
                            </div>
                            <div className='col-sm-12 col-md-12 col-lg-12'>
                                <div className='col-sm-4 col-md-4 col-lg-4'>
                                    <BioDevice />
                                </div>
                            </div>
                            <div className='col-sm-6 col-md-4 col-lg-4'>
                                <label></label>
                                <div className='col-md-12 d-flex align-items-center'>
                                    <div className="form-group mr-3">
                                        <button
                                            type="button"
                                            className="btn btn-default rounded-pill pl-4 pr-4"
                                            onClick={clearFormField}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                    <div className="form-group">
                                        <button
                                            type="button"
                                            className="btn btn-primary rounded-pill pl-4 pr-4"
                                            onClick={scanFinger}
                                            disabled={isConsent === 'N' || !isDeviceConnected}
                                        >
                                            <i className="fas fa-fingerprint"></i> Scan Finger
                                        </button>
                                    </div>
                                </div>
                                <div className="col-md-12 mt-2">
                                    {isDeviceConnected ? (
                                        <span className="text-success fw-bold">
                                            🟢 Fingerprint Device Connected
                                        </span>
                                    ) : (
                                        <span className="text-danger fw-bold">
                                            🔴 Fingerprint Device Not Connected
                                        </span>
                                    )}
                                </div>
                                {!isDeviceConnected && (
                                    <div className="col-md-12 text-muted small mt-1">
                                        Please connect fingerprint device to enable scanning
                                    </div>
                                )}
                            </div>
                        </div>}

                        {isAuthAePSModel && <Modal title={isAuthAePSTitle} width={600} open={isAuthAePSModel} onCancel={() => handleCloseModal()} footer={false} >
                            <>
                                <div className='text-center h-100'>
                                    <img src={'./../fingerprint-svgrepo-com.svg'} alt='' width={'175px'} />
                                </div>
                                <div className='col-sm-12 col-md-12 col-lg-12 mb-120'>
                                    <div className='form-group'>
                                        <Checkbox className='d-flex' checked={isConsent} onChange={onChangeChackBox}>I hereby give my voluntary consent to SR PAY Private Limited, use my Aadhaar/ VID number & biometric to authenticate from UIDAI for the purpose of AEPS transaction.</Checkbox>
                                    </div>
                                </div>
                                <BioDevice />
                                <button className='btn btn-primary btn-lg bg-primary btn-block' onClick={() => scanFingerPrintData()}>Scan Finger</button>
                            </>
                        </Modal>}

                        {/* 🔥 OTP Popup Modal */}
                        {showOtpPopup && (
                            <Modal
                                title="OTP Verification"
                                width={400}
                                open={showOtpPopup}
                                onCancel={() => {
                                    if (timerIntervalRef.current) clearInterval(timerIntervalRef.current);
                                    setShowOtpPopup(false);
                                }}
                                footer={null}
                                closable={true}
                            >
                                <div className="text-center">
                                    <p>OTP sent to your registered mobile number</p>
                                    <div className="mb-2">
                                        <Input.OTP
                                            length={6}
                                            value={otpValue}
                                            onChange={(value) => setOtpValue(value)}
                                            disabled={otpExpired}
                                        />
                                    </div>
                                    <div className="mb-2">
                                        {!otpExpired ? (
                                            <span>Time remaining: <strong>{otpTimer}</strong> seconds</span>
                                        ) : (
                                            <span className="text-danger">OTP expired</span>
                                        )}
                                    </div>
                                    <div className="mb-2">
                                        {otpExpired && (
                                            <Button type="link" onClick={resendOtp}>
                                                Resend OTP
                                            </Button>
                                        )}
                                    </div>
                                    <div className="mt-3">
                                        <Button
                                            type="primary"
                                            onClick={verifyOtp}
                                            disabled={otpValue.length < 6 || otpExpired}
                                            loading={otpLoading}
                                        >
                                            Verify OTP
                                        </Button>
                                        <Button
                                            className="ml-2"
                                            onClick={() => {
                                                if (timerIntervalRef.current) clearInterval(timerIntervalRef.current);
                                                setShowOtpPopup(false);
                                            }}
                                        >
                                            Cancel
                                        </Button>
                                    </div>
                                </div>
                            </Modal>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Cashwithdrawal;